import { createElement } from 'react';
const TextWithImage = (props) => {
    const { width, height, contentWidth } = props;
    return (createElement("div", { style: { display: 'flex', width: `${width}px`, height: `${height}px` } },
        createElement("div", { style: {
                width: `${contentWidth}px`,
                marginRight: '10px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            } },
            createElement("div", null,
                props.children[0],
                props.children[1]),
            createElement("div", null, props.children[2])),
        createElement("div", null, props.children[3])));
};
export default TextWithImage;
